import { render, staticRenderFns } from "./LessonsList.vue?vue&type=template&id=dd9a16f2&"
import script from "./LessonsList.vue?vue&type=script&lang=ts&"
export * from "./LessonsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports